import React from 'react';
import CustomizedTooltip from '../Tooltip/Tooltip';

import {ReactComponent as AiPurpleIcon} from '../../assets/ai.svg';

type AiIconProps = {
    dataQa?: string;
    dataTestId?: string;
    mode?: string;
    title?: string;
    forceTooltip?: string;
};

export const AiIcon: React.VFC<AiIconProps> = ({
    dataQa,
    dataTestId,
    title,
    forceTooltip,
}) => {

    return (
        <CustomizedTooltip
            title={
                forceTooltip
                    ? forceTooltip
                    : title

            }
            dataQa={dataQa}
            dataTestId={dataTestId}
            copy={false}
        >
            <div style={{ marginTop: 5 }} data-testid={`${dataTestId}-icon`}>
                <AiPurpleIcon/>
            </div>
        </CustomizedTooltip>
    );
};
